// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { createSecureSupabaseConfig } from '@/lib/secureAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ndlgqqolvvwmhlhpycqo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5kbGdxcW9sdnZ3bWhsaHB5Y3FvIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzEwMTMzMjAsImV4cCI6MjA2OTgzNjcyMH0.GS33kaJDXjFJNmx7M4Z21VdtQ0jqENff7q1L4NMXn4U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  ...createSecureSupabaseConfig(),
  global: {
    headers: {
      'x-client-info': 'consent-guard-web-app'
    }
  }
});

export { clearSecureAuthStorage } from '@/lib/secureAuthStorage';